export enum EnvironmentName {
  Local = 'Local',
  Test = 'Test',
  Staging = 'Staging',
  Production = 'Production',
}
